import { all } from "redux-saga/effects";
import { watchAuthentication } from "../pages/Layout/saga";

function* rootSaga() {
  yield all([watchAuthentication()]);
}
export default rootSaga;
